import { BaseService } from './base-service';
import { Organization } from '@/types/entities';
import { GetOrganizationsResponseDTO } from '@/core/dto/organization/get-organizations';

export class OrganizationService extends BaseService<Organization> {
	private static instance: OrganizationService;

	private constructor(public readonly basePath: string = '/organization') {
		super();
	}

	public static getInstance(): OrganizationService {
		if (!OrganizationService.instance) {
			OrganizationService.instance = new OrganizationService();
		}
		return OrganizationService.instance;
	}

	public async index(): Promise<GetOrganizationsResponseDTO> {
		const url = this.basePath + '/user_list';
		const { data } = await this.getInstance().get<GetOrganizationsResponseDTO>(url);
		return data;
	}
}
